import React, { useEffect, useRef } from "react";
import UserMessage from "./user/user_message.js";
import AiMessage from "./ai/ai_message.js";
import CourseRecommendations from "./course_recommendations/course_recommendations.js";

function Messages({ messages, threeDots, host }) {
	const messagesEndRef = useRef(null);


	const scrollToBottom = () => {
		// Ensure the scroll behavior is smooth for a good user experience
		messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
	};
	
	useEffect(() => {
		// Add a small delay to ensure the messages are fully rendered before scrolling
		const timer = setTimeout(scrollToBottom, 100);
		return () => clearTimeout(timer);
	}, [messages, threeDots]); // Run whenever messages or threeDots changes

	return (
		<div className="messagesContainer">
			{messages.map((msg, index) => {
				if (msg.isUser === true) {
					return <UserMessage key={index} message={msg.message} className="userMessage" />;
				} else if (msg.isUser === false) {
					return <AiMessage key={index} message={msg.message} threeDots={index === messages.length - 1 && threeDots} className="aiMessage" />;
				} else if (msg.isUser === null && msg.courseDetails) {
					return (
						<CourseRecommendations
							key={index}
							recommendation={msg.courseDetails}
							className="recommendations"
							host={host}
						/>
					);
				}
				return null;
			})}
			{/* Ref to ensure the last element is in view */}
			<div ref={messagesEndRef} />
		</div>
	);
}

export default Messages;
